<div [formGroup]="form">

    <app-ativacao-section-card
        [control]="ativoControl"
        titulo="Monofásica Retida Anteriormente"
        [exibirTituloNoAlerta]="false"
        descricaoAtivo="Modalidade retida anteriormente ativa. As alíquotas por unidade abaixo serão aplicadas no cálculo."
        descricaoInativo="Modalidade retida anteriormente inativa. Ative para informar as alíquotas por unidade já retidas de IBS e CBS."
        emptyStateTitulo="Monofásica Retida Anteriormente desativada"
        emptyStateDescricao="Ative a modalidade retida anteriormente acima para informar as alíquotas por unidade de IBS e CBS.">
    </app-ativacao-section-card>

    @if (ativoControl.value) {
    <div class="section-container">
        <div class="section-title">
            <mat-icon class="material-symbols-outlined">history</mat-icon>
            <span>Monofásica Retida Anteriormente</span>
            <div class="section-title-actions ms-auto">
                <button mat-button type="button" class="btn-section" [matBadge]="personalizadasCount" [matBadgeHidden]="personalizadasCount === 0" (click)="abrirEditorFormulas()">
                    <mat-icon class="material-symbols-outlined">settings</mat-icon>
                    Personalizar fórmulas
                </button>
            </div>
        </div>

        <div class="row g-3">
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade IBS (retida ant.)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemIbsRet">
                    <mat-error>{{ form.get('adRemIbsRet')?.hasError('min') ? 'O ad rem do IBS do monofásico retido anteriormente não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico retido anteriormente.' }}</mat-error>
                </mat-form-field>
            </div>
            <div class="col-12 col-md-4">
                <mat-form-field appearance="outline" class="w-100" subscriptSizing="dynamic">
                    <mat-label>Alíquota por unidade CBS (retida ant.)</mat-label>
                    <input matInput type="text" inputmode="numeric" [currencyMask]="currencyMask" formControlName="adRemCbsRet">
                    <mat-error>{{ form.get('adRemCbsRet')?.hasError('min') ? 'O ad rem da CBS do monofásico retido anteriormente não pode ser negativo.' : 'Informe o ad rem do IBS e da CBS do monofásico retido anteriormente.' }}</mat-error>
                </mat-form-field>
            </div>
        </div>
    </div>
    }
</div>
